import { IFullStop } from 'types/shipment'
import { VerifyShipmentResponseObject } from 'apps/marketplace/apiTypes/shipments'

/**
 * Reads the simplified stops object from the /verify_shipment response
 * and returns an IFullStop[] that can be consumed by more components.
 */
export const getStopsFromVerifyShipmentResponse = (
  verificationResponse: VerifyShipmentResponseObject | null
): IFullStop[] => {
  const { shipment } = verificationResponse || {}

  if (!shipment) return []

  const { stops: reducedStops = [] } = shipment
  return reducedStops.map(stopData => {
    return {
      type: stopData.stopType,
      facility: {
        city: stopData.city,
        stateCode: stopData.stateCode,
      },
      appointment: {
        startAt: stopData.date,
        timezone: stopData.displayTimezone,
      },
    } as IFullStop
  })
}
